import React from "react";
import { Link } from "react-router-dom";
import "./BlogPreview.css";

const ArticlePreview = ({
  posts,
  title = "📜 Scrolls of Wisdom",
  showDiscoverAll = false,
}) => (
  <section className="blog-preview">
    <h2 style={{ textAlign: "center" }}>{title}</h2>
    <div className="blog-list">
      {posts && posts.length > 0 ? (
        posts.map((post) => (
          <Link to={`/articles/${post.slug}`} key={post.slug} className="blog-card-link">
            <div className="blog-card">
              <h3>{post.title}</h3>
              <p className="blog-date">{post.date}</p>
              <p className="blog-excerpt">{post.excerpt}</p>
              <span className="blog-readmore">
                Read scroll →
              </span>
            </div>
          </Link>
        ))
      ) : (
        <p>No scrolls discovered yet.</p>
      )}
    </div>
    {showDiscoverAll && (
      <div style={{ textAlign: "left", marginTop: "1.5rem" }}>
        <Link to="/articles" className="discover-scrolls-link">
          🔎 Discover all scrolls
        </Link>
      </div>
    )}
  </section>
);

export default ArticlePreview;
